/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reason: NonNullable<unknown> }} Twda_Status_FailedInputs */



/**
* | output |
* | --- |
* | "TWDA submission failed — {reason}. The winner's deck did not reach the archive." |
*
* @param {Twda_Status_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_status_failed = /** @type {((inputs: Twda_Status_FailedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Status_FailedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`La soumission au TWDA a échoué — ${i?.reason}. Le deck du vainqueur n'a pas atteint l'archive.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Envío al TWDA fallido — ${i?.reason}. El mazo del ganador no llegó al archivo.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Envio para o TWDA falhou — ${i?.reason}. O deck do vencedor não chegou ao arquivo.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Invio al TWDA fallito — ${i?.reason}. Il mazzo del vincitore non ha raggiunto l'archivio.`)
	return /** @type {LocalizedString} */ (`TWDA submission failed — ${i?.reason}. The winner's deck did not reach the archive.`)
});